import React from 'react';
import { AlertCircle, Users, MessageSquare, Star } from 'lucide-react';

const kpis = [
  {
    id: 'kpi-pending',
    label: 'Pending Reviews',
    value: '7',
    subtext: '3 submitted today',
    icon: AlertCircle,
    iconColor: 'text-red-400',
    iconBg: 'bg-red-400/10',
    borderColor: 'border-red-400/20',
    alert: true,
  },
  {
    id: 'kpi-live',
    label: 'Live Experts',
    value: '84',
    subtext: '+6 this week',
    icon: Users,
    iconColor: 'text-secondary',
    iconBg: 'bg-secondary/10',
    borderColor: 'border-border',
    alert: false,
  },
  {
    id: 'kpi-queries',
    label: 'Total Queries',
    value: '312',
    subtext: '28 active / open',
    icon: MessageSquare,
    iconColor: 'text-primary',
    iconBg: 'bg-primary/10',
    borderColor: 'border-border',
    alert: false,
  },
  {
    id: 'kpi-rating',
    label: 'Avg Platform Rating',
    value: '4.28',
    subtext: 'Across 206 ratings',
    icon: Star,
    iconColor: 'text-primary',
    iconBg: 'bg-primary/10',
    borderColor: 'border-border',
    alert: false,
  },
];

export default function AdminKPIs() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {kpis?.map((kpi) => {
        const IconComponent = kpi?.icon;
        return (
          <div
            key={kpi?.id}
            className={`surface-elevated p-5 flex flex-col gap-3 ${kpi?.alert ? 'border-red-400/20' : ''}`}
          >
            <div className="flex items-center justify-between">
              <span className="text-xs font-mono-data text-muted-foreground uppercase tracking-wider">{kpi?.label}</span>
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${kpi?.iconBg}`}>
                <IconComponent size={15} className={kpi?.iconColor} />
              </div>
            </div>
            <div>
              <div className={`font-mono-data text-3xl font-bold ${kpi?.alert ? 'text-red-400' : 'text-foreground'}`}>
                {kpi?.value}
              </div>
              <div className="text-xs text-muted-foreground mt-1">{kpi?.subtext}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}